module.exports = __webpack_public_path__ + "media/assets/stores/apple-1c7dfa4703959c1b0b58d3827e1f989d.png";